import React, { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { authTokensContext } from "../../context/authToken";
import { SuspenseHOC } from "../SuspenseHOC";
import { AuthTokenContextType } from "../../@types/authToken";

const PrivateRoute = ({ allowGuest = false }: { allowGuest?: boolean }) => {
	const { authToken } = useContext(authTokensContext) as AuthTokenContextType;
	const location = useLocation();
	const isGuestCheckout =
		allowGuest && new URLSearchParams(location.search).get("guest") === "1";
	return authToken || isGuestCheckout ? (
		<Outlet />
	) : allowGuest ? (
		<Navigate replace to="/checkout?guest=1" />
	) : (
		<Navigate replace to="/login" />
	);
};

export default SuspenseHOC(PrivateRoute);
